window.fbAsyncInit = function () {
    FB.init({
        appId: window.config.Statics.FacebookId,
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v2.11'
    });
    FB.AppEvents.logPageView();
};

(function(d, s, id){
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {return;}
    js = d.createElement(s); js.id = id;
    js.src = "https://connect.facebook.net/en_US/sdk.js";
    fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'facebook-jssdk'));


//COMPARTIR EN NOTA ----------------------------------------------------------------------
export function popUpCompartirNotaFB(notaId, dominio, titulo) {
    if (notaId.length > 0) {
        FB.ui({
                method: 'share',
                mobile_iframe: true,
                href: `${dominio}${notaId}`
            },
            function(response) {});
        //popUpRedSocial(`//www.facebook.com/sharer.php?m2w&s=100&p[url]=${dominio}${notaId}`);
    } else {
        window.open("https://www.facebook.com/lanacion", "_blank");
    }
}

export function popUpCompartirNotaTW(notaId, dominio, titulo) {
    if (notaId.length > 0) {
        popUpRedSocial("//twitter.com/share?text=" + titulo + "&url=" + dominio + notaId + "&via=LANACION"); //$("#hs-twitter").val());
    }
    else {
        window.open("//twitter.lanacion.com.ar/", "_blank");
    }
};

export function popUpCompartirNotaGoogle(notaId, dominio, titulo) {
    if (notaId.length > 0) {
            popUpRedSocial("//plus.google.com/share?url=" + dominio + notaId); //$("#hs-twitter").val());
    }
    else {
        window.open("https://plus.google.com/+lanacion", "_blank");
    }
};

export function popUpCompartirMailTo(notaId , dominio) {
    if (notaId.length > 0) {
        popUpRedSocial(dominio + "herramientas/nota/enviar-por-mail.html?nota_id" + notaId); 
    }
};

export function popUpCompartirNotaRss() {
    window.open("http://servicios.lanacion.com.ar/herramientas/rss/ayuda", '_blank');
};

function popUpRedSocial(url) {
    open(url, "", "top=300,left=550,width=800,height=380");
};

export const shareWhastApp = () => {
    try {
        $(".share-whatsapp").each(function (i, nodo) {
            const notaId = $(nodo).attr("data-notaId"),
                texto = $(nodo).attr("data-text") + ": " + $(nodo).attr("data-titulo");

            $(nodo).click(function () {
                const whatsappUrl = `whatsapp://send?text=${texto} - ${window.config.Statics.DominioUrl}${notaId}`;
                window.location.href = whatsappUrl;
            });
        });
    
        /***** Whatsapp  *****/
        if (/Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            $(".wapp").css("display", "inline-block");
            $("body").addClass("touch");
        }
    }
    catch (e) {
        console.warn && console.warn("Initialize: ", e);
    }
}


// WEBPACK FOOTER //
// ./Statics/scripts/common/compartir.js